import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'

// API
import * as API from '../../../../utils/api';

// Components
import ProfileImage from "../../../Profile/ProfileImage"
import AppCanvasLoader from '../../../../components/Global/AppCanvasLoader';

class ProfileImageUploader extends Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    participationID: PropTypes.number.isRequired,
    updateParticipation: PropTypes.func.isRequired,

    // from redux
    user: PropTypes.object
  }

  state = {
    uploading: false
  }

  onDropAccepted = (acceptedFiles) => {
    this.setState({uploading: true}, () => this.upload(acceptedFiles[0]))
  }

  upload = (file) => {
    const { user, participationID, updateParticipation } = this.props

    API.uploadProfileImage(user, participationID, file)
    .then(() => {
      updateParticipation()
      this.setState({uploading: false})
    })
  }

  onDropRejected = (rejectedFiles) => {
    this.props.setFlashMessage('error', 'Error: Image file size exceeded 500 kb limit. Please try uploading an image less than 500 kb.', true)
  }

  render() {
    const { imageUrl } = this.props
    const { uploading } = this.state

    return (
      <ProfileImage image={ imageUrl } >
        <Dropzone
          className="profile-image-uploader content"
          onDropAccepted={this.onDropAccepted}
          onDropRejected={this.onDropRejected}
          accept="image/*"
          multiple={false}
          disabled={uploading}
          maxSize={500000}
        >
          { uploading ? <AppCanvasLoader /> : <span>Click to change</span> }
        </Dropzone>
      </ProfileImage>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(ProfileImageUploader)



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/Profile/ProfileImageUploader.js